module.exports = __webpack_public_path__ + "static/media/cube.5418f96b.svg";